import React from 'react';
import {Link} from 'react-router-dom';
import DemandCompose from './DemandCompose';
import '../styles/demands.css';
export default function InterestDialog({venue,context,onClose,onSuccess}){
  return venue ? <DemandCompose key={venue.id} testId="interest-dialog" role="organizer" target={venue} projectId={context?.project_id||null}
      brief={{title:context?.project_title||'Etkinlik iş birliği',summary:context?.free_text||''}} criteria={context?.applied_filters||{}}
      onClose={onClose} onSent={row=>onSuccess({...venue,application_id:row.id})}/> : null;
}
export function InterestSuccess({venue}){
  return venue?<div role="status" className="my-4 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900"><strong>{venue.name}: Talebin gönderildi.</strong><p>Mekânın yanıtı bekleniyor. Güncellemeleri Taleplerim ekranında takip edebilirsin.</p><Link className="text-action underline" to={`/organizer/applications${venue.application_id?`?application=${encodeURIComponent(venue.application_id)}`:''}`}>Talebimi aç</Link></div>:null;
}
